import { useTranslation } from "react-i18next";

import Directory from "Components/Directory/Directory";

// Colores de marca de Crontu, tomados del handoff de Figma
// (mismo violeta que usa App/Setup/Resources/Form/Crontu)
export const CRONTU_COLOR = "#6566f4";
// Recuadro con cartilla: relleno violeta claro y sin borde
export const CRONTU_BACKGROUND = "#f2f4fd";
// Recuadro de configuración: fondo blanco y borde apenas marcado
export const CRONTU_BORDER = "#eef1ff";

// Recuadro de la cartilla de Crontu. Todo el comportamiento vive en Components/Directory;
// acá sólo la marca y de dónde sale el link del profesional.
//
// props propios (el resto pasa tal cual a Directory):
//   resource → profesional; de acá sale el id para el link de configuración
//   link     → URL de Crontu. La fuente de verdad es Crontu, no el resource: quien use
//              este componente la resuelve con hooks/useCrontuLinks
//   to       → destino del recuadro de configuración cuando todavía no hay cartilla;
//              por defecto la ficha del profesional, o el listado si no se sabe cuál
const Crontu = ({ resource, link, to, label, ...props }) => {
  const { t } = useTranslation();

  const url = link || "";
  const resourceID = (resource?.id || "").replace("resources/", "");
  const setup =
    to ||
    (resourceID
      ? window._l(`/setup/resources/${resourceID}/crontu`)
      : window._l("/setup/resources"));

  return (
    <Directory
      logo="/images/crontu-logo.png"
      alt="Crontu"
      color={CRONTU_COLOR}
      // Mismo borde en todos los recuadros de Crontu; lo que cambia es el relleno:
      // violeta claro cuando hay cartilla, blanco en el de configuración.
      background={url ? CRONTU_BACKGROUND : "#ffffff"}
      border={CRONTU_BORDER}
      url={url}
      to={url ? undefined : setup}
      // `label` se resuelve acá y no por spread: quien lo pase en undefined no debe
      // borrar el texto del recuadro de configuración.
      label={label || (url ? undefined : t("resource_setup_crontu", "Configurar Crontu"))}
      {...props}
    />
  );
};

export default Crontu;
